import { AppServiceCategoryNamesEnum } from '../models/app-service-category-names.enum';

export const AppServiceCategoryDescriptionConst = {
  [AppServiceCategoryNamesEnum.PAY]: 'خدمات پرداخت',
  [AppServiceCategoryNamesEnum.MOBILE]: 'خدمات موبایل',
  [AppServiceCategoryNamesEnum.WEALTH]: 'مدیریت ثروت',
  [AppServiceCategoryNamesEnum.INSURANCE]: 'خدمات بیمه',
  [AppServiceCategoryNamesEnum.VEHICLE]: 'خدمات خودرو',
  [AppServiceCategoryNamesEnum.INSTALLMENT]: 'خرید اقساطی',
  [AppServiceCategoryNamesEnum.SUGGESTED_SERVICES]: 'خدمات پیشنهادی',
};
